import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { allFilterApprovalList } from "../../api/approval";
import dayjs from "dayjs";

const useApprovalFilter = ({showList, requisition_role, callback, status, self = false }) => {
  const allStatuses = [{
    label: 'Approval pending',
    value: 'APPROVAL_PENDING'
  },{
    label: 'Exess Quantity',
    value: 'EXCESS_APPROVED'
  },{
    label: 'Partial apprved',
    value: 'PARTIALLY_APPROVED'
  },{
    label: 'Complete Approved',
    value: 'COMPLETE_APPROVED'
  },{
    label: 'Saved',
    value: 'SAVED'
  }]
  const [productList, setProductList] = useState([]);
  const [reqNoList, setReqNoList] = useState([]);
  const [statusList, setStatusList] = useState([])
  const [executiveList, setExecutiveList] = useState([]);
  const [filterPayload, setFilterPayload] = useState({
    product: null,
    reqNo: null,
    executive: null,
    startDate: null,
    endDate: null,
    status: null,
  });
  const fetchFilterList = async () => {
    try {
      let payload = {
        filter_type: ["product", "reqNo", "executive"],
        requisition_role,
        self
      }
      if (status) payload = {...payload, status}
      if (self) payload = {...payload, filter_type: ["product", "reqNo", "status"],}
      const res = await allFilterApprovalList(payload);
      if (res.statusCode === 200 && res.data) {
        const {product = [], reqNo = [], executive = [], status = []} = res.data
        setProductList(product);
        setReqNoList(reqNo);
        setExecutiveList(executive);
        if (status.length > 0) {
          const filteredStatus = allStatuses.filter((item) => status.includes(item.value))
          setStatusList(filteredStatus)
        }

      }
    } catch (error) {
      toast.error("Error in fetching filters list for sales head");
      console.log(error);
    }
  };

  const handleSearch = async () => {
    const { startDate, endDate, executive, reqNo, product, status } = filterPayload;
    if ((startDate && !endDate) || (!startDate && endDate)) {
      toast.error("Please select valid daterange.");
      return;
    }
    let payload = {};
    if (startDate && endDate) {
      payload.startDate = dayjs(startDate).format("YYYY-MM-DD");
      payload.endDate = dayjs(endDate).format("YYYY-MM-DD");
    }
    if (product) {
      payload.product = product.value;
    }

    if (reqNo) {
      payload.reqNo = reqNo.value;
    }
    if (executive) {
      payload.executive = executive.value;
    }
    if (status) {
      payload.status = status.value;
    }
    await callback(payload)
  };

  const handleResetFilter = () => {
    setFilterPayload({
      product: null,
      reqNo: null,
      executive: null,
      startDate: null,
      endDate: null,
      status: null
    });
  };

  const handleReset = () => {
    handleResetFilter();
    callback();
  };

  useEffect(() => {
    if (showList && productList.length === 0 && reqNoList.length === 0 && executiveList.length === 0) {
      fetchFilterList();
    }
}, [showList])

  return {
    productList,
    reqNoList,
    executiveList,
    statusList,
    filterPayload,
    setProductList,
    setReqNoList,
    setExecutiveList,
    setFilterPayload,
    fetchFilterList,
    handleSearch,
    handleResetFilter,
    handleReset,
  };
};

export { useApprovalFilter };
